/**
 * @generated SignedSource<<9bed57b5d438b60d469c421b5a829a65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTable_nativeIssueTable_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"header_nativeIssueTable">;
  readonly " $fragmentType": "issueTable_nativeIssueTable_view";
};
export type issueTable_nativeIssueTable_view$key = {
  readonly " $data"?: issueTable_nativeIssueTable_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueTable_nativeIssueTable_view",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "header_nativeIssueTable"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "6274d6e3d3b28be9b9e64979f1543d09";

export default node;
